var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank-footer"},[_c('a',{staticClass:"link-to-bank",attrs:{"href":_vm.source.links.login,"target":"_blank"}},[_c('img',{attrs:{"src":require(("@/assets/bank-logos/" + (_vm.source.logoFile)))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }